/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class ResetPassword extends PageStringSection {
    button_resetPassword_label: string = "Labels.lbl_Save";
    button_clickHere_label: string = "Labels.lbl_ClickHere";
    error_passwordIncorrectFormat: string = "Messages.msg_DataEntryIncorrectFormat";
    error_passwordReset: string = "Messages.msg_PasswordChangeFailed";
    error_passwordLinkExpired: string = "Messages.msg_PasswordLinkExpired";
    error_passwordMismatch: string = "Messages.msg_PasswordMismatch";
    formItem_confirmPassword_label: string = "Labels.lbl_PasswordConfirm";
    formItem_confirmPassword_placeholder: string = "Labels.lbl_PasswordConfirm";
    formItem_password_label: string = "Labels.lbl_Password";
    formItem_password_placeholder: string = "Labels.lbl_Password";
    heading_resetPassword: string = "Messages.msg_ResetPassword";
    message_passwordResetSuccess: string = "Messages.msg_PasswordChanged";
    text_passwordRequirements_lowerCase: string = "Messages.msg_PasswordRequirements_LowerCaseRequired";
    text_passwordRequirements_minimumCharacters: string = "Messages.msg_PasswordRequirements_MinimumCharacters";
    text_passwordRequirements_number: string = "Messages.msg_PasswordRequirements_NumberRequired";
    text_passwordRequirements_specialCharacters: string = "Messages.msg_PasswordRequirements_SpecialCharactersRequired";
    text_passwordRequirements_upperCase: string = "Messages.msg_PasswordRequirements_UpperCaseRequired";
    text_validatingToken: string = "Messages.msg_Validating";
}
